export default {
    state: {
        publications: [],
        publication: []
    },
    mutations: {
        setPublications (state, payload) {
            state.publications = payload
        },
        setPublication (state, payload) {
            state.publication = payload
        }
    },
    actions: {
        getPublications (context, publication_id) {
            return new Promise((resolve, reject) => {
                if (publication_id) {
                    this._vm.axios.get('/api/publications/' + publication_id)
                    .then(response => {
                        context.commit('setPublication', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                } else {
                    this._vm.axios.get('/api/publications')
                    .then(response => {
                        context.commit('setPublications', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                }
            })
        },
        getTrunks (context, publication_id) {
            return new Promise((resolve, reject) => {
                if (publication_id) {
                    this._vm.axios.get('/api/publications/' + publication_id)
                    .then(response => {
                        context.commit('setPublication', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                } else {
                    console.log('else');
                    this._vm.axios.get('/api/trunks')
                    .then(response => {
                        context.commit('setPublications', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
                }
            })
        }
        
    }
}
